import SvgIcon from "components/base/SvgIcon";
import { X } from "lucide-react";
import { forwardRef } from "react";
import { cn } from "utils";

const ChipContent = (
  {
    skill,
    active,
    isAiGenerated,
    onClick,
    onRemove,
    isDragging = false,
    isOverlay = false,
    ...rest
  },
  ref
) => {
  const { name } = skill;

  return (
    <div
      className={cn(
        "px-2 py-1 flex h-fit rounded-lg text-start origin-center",
        {
          "bg-sky-600 text-white": active,
          "bg-sky-50 text-sky-600 font-normal": !active,
          "invisible pointer-events-none": isDragging && !isOverlay,
        }
      )}
      onClick={onClick}
      ref={ref}
      {...rest}
    >
      <div
        className={cn("pl-1 pr-2 border-r relative", {
          "border-sky-500": active,
          "border-sky-100": !active,
        })}
      >
        {/* 
          Hacky way to prevent layout shift from font weight change
          Notably, this will duplicate the content in the markup
          This is likely safe due to our usecases and primarily internal usage
        */}
        <span
          className={cn("items-center gap-1 flex font-semibold", {
            "opacity-100": active,
            "opacity-0": !active,
          })}
        >
          {isAiGenerated && <SvgIcon type={"aiSparkles"} />}
          {name}
        </span>
        <span
          className={cn(
            "absolute top-0 left-1 flex items-center gap-1 line-through",
            {
              visible: !active,
              invisible: active,
            }
          )}
          aria-hidden="true"
        >
          {isAiGenerated && <SvgIcon type={"aiSparkles"} />}
          {name}
        </span>
      </div>

      <div className="pl-1 pr-1">
        <button
          className={cn(
            "flex justify-center items-center h-full w-auto text-inherit rounded-full aspect-square transition-colors",
            {
              "hover:bg-sky-700": active,
              "hover:bg-sky-100": !active,
            },
            "remove-chip"
          )}
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.();
          }}
          id={`remove-chip-${skill.name}`}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default forwardRef(ChipContent);
